module.exports = __webpack_public_path__ + "assets/img/u5e706f0bc7f30.93e26345.png";